import React from "react";
import { Switch, message } from "antd";
import { ReactComponent as FooterHash } from "../../../assets/images/ChatImages/footerhash.svg";
import { ReactComponent as FooterMenu } from "../../../assets/images/ChatImages/footermenu.svg";
import { ReactComponent as TagIcon } from "../../../assets/images/ChatImages/tag-icon.svg";
import { ReactComponent as Cancel } from "../../../assets/images/TicketImages/cancel.svg";
import TagMenu from "./TagMenu";
import { useSelector, useDispatch } from "react-redux";
import { addTagsToChat } from "../../../store/features/addTagsToChat";
import { fetchTags } from "../../../store/features/tagsApi";

function ChatMessageFooter({
  isPrivate,
  setIsPrivate,
  isFromTicket,
  roomId,
  tags,
  variant,
  hidePrivateMode,
  tagsLabel = "Add tags",
}) {
  const dispatch = useDispatch();
  const [showTagMenu, setShowTagMenu] = React.useState(false);
  const [selectedTagIds, setSelectedTagIds] = React.useState([]);
  const [showToast, setShowToast] = React.useState(false);

  const { list: availableTags = [] } = useSelector((state) => state.tags);
  const { loginToken, loginTokenCoUser } = useSelector((state) => state);
  const businessId =
    loginToken?.response?.user?.business_id ||
    loginTokenCoUser?.response?.user?.business_id;

  React.useEffect(() => {
    if (businessId && (!availableTags || availableTags.length === 0)) {
      dispatch(fetchTags({ businessId, type: "conversation" }));
    }
  }, [availableTags?.length, businessId, dispatch]);

  const getTagObjects = (ids) =>
    availableTags.filter((tag) => ids.includes(tag._id));

  React.useEffect(() => {
    if (!Array.isArray(tags)) {
      setSelectedTagIds([]);
      return;
    }
    const first = tags[0];
    const areObjects = first && typeof first === "object" && first._id;
    if (areObjects) {
      setSelectedTagIds(tags.map((t) => t._id));
    } else {
      setSelectedTagIds(tags);
    }
  }, [tags]);

  const selectedTags = React.useMemo(
    () => getTagObjects(selectedTagIds),
    [selectedTagIds, availableTags]
  );

  const handleSelectTag = (nextSelectedIds) => {
    const uniqueIds = Array.from(new Set(nextSelectedIds));
    if (uniqueIds.length > 5) {
      message.warning("You can add up to 5 tags only.");
      setSelectedTagIds(uniqueIds.slice(0, 5));
      return;
    }
    setSelectedTagIds(uniqueIds);
  };

  const handleRemoveTag = async (tagId) => {
    const updatedIds = selectedTagIds.filter((id) => id !== tagId);
    setSelectedTagIds(updatedIds);

    if (roomId) {
      try {
        await dispatch(
          addTagsToChat({
            room_id: roomId,
            tag_ids: updatedIds,
            business_id: businessId,
          })
        ).unwrap();
      } catch (error) {
        console.error("Error updating tags:", error);
        setSelectedTagIds((prev) => {
          return Array.from(new Set([...prev, tagId]));
        });
      }
    }
  };

  const truncateText = (text, maxLength = 20) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };
  return (
    <div className="ChatMessage-Footer">
      <div className="ChatMessage-Footer01">
        {isFromTicket ? (
          <div className="ChatMessage-Footer-div01">
            <p className="ChatFooter-text">Type</p>
            <FooterHash style={{ cursor: "pointer" }} />
            <p className="ChatFooter-text">for canned response</p>
            <FooterMenu style={{ cursor: "pointer" }} />
            <p className="ChatFooter-text">for emoji</p>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "start",
                gap: "16px",
                width: "100%",
              }}
            >
              {/* Left side - Add tags and selected tags */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {/* Add tags button */}
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor:
                      selectedTagIds.length >= 5 ? "not-allowed" : "pointer",
                    opacity: selectedTagIds.length >= 5 ? 0.5 : 1,
                    pointerEvents: selectedTagIds.length >= 5 ? "none" : "auto",
                    height: "32px",
                  }}
                  onClick={() => {
                    if (selectedTagIds.length < 5) setShowTagMenu((v) => !v);
                  }}
                >
                  {variant === "v2" || hidePrivateMode ? (
                    <p
                      className={variant === "v2" ? "chatv2-tags-label" : undefined}
                      style={
                        hidePrivateMode && variant !== "v2"
                          ? {
                              fontWeight: 500,
                              color: "#061522",
                              marginRight: "8px",
                              lineHeight: "32px",
                              fontSize: "14px",
                            }
                          : undefined
                      }
                    >
                      Tags:
                    </p>
                  ) : (
                    <>
                      <TagIcon />
                      <p
                        className="ChatFooter-text"
                        style={{
                          fontWeight: 500,
                          color: "#061522",
                          marginRight: "10px",
                          marginLeft: "8px",
                          lineHeight: "32px",
                          fontSize: "14px",
                        }}
                      >
                        {tagsLabel}
                      </p>
                    </>
                  )}
                </span>

                {/* Selected tags */}
                {selectedTags.map((tag) => (
                  <span
                    key={tag._id}
                    className="TicketTag"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: 999,
                      justifyContent: "space-between",
                      border: "1px solid #CBD5DF",
                      // padding: "0px 8px",
                      height: "32px",
                      fontWeight: 500,
                      overflow: "hidden",

                      background: "#F9FAFB",
                      color: "#405261",
                      maxWidth: "300px", // Increased to handle long IDs
                      fontSize: "14px",
                    }}
                  >
                    <span
                      style={{
                        // overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "250px",
                        fontSize: '12px'

                      }}
                      title={tag.name}
                    >
                      {tag.name}
                    </span>
                    <span

                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: 8,
                        cursor: "pointer",
                        fontSize: 16,
                        flexShrink: 0,
                        lineHeight: "32px",
                      }}
                      onClick={() => handleRemoveTag(tag._id)}
                    >
                      <Cancel />
                    </span>
                  </span>
                ))}
              </div>

              {/* Right side - Private Mode (fixed position) */}
              {!isFromTicket && variant !== "v2" && !hidePrivateMode && (
                <div
                  className="privateMode-Container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    height: "32px",
                    justifySelf: "end",
                  }}
                >
                  <p className="privateMode-text" style={{ marginRight: '9px' }}>
                    Private Mode
                  </p>
                  <Switch
                    checked={isPrivate}
                    onChange={setIsPrivate}
                    style={{ minWidth: "36px", height: "20px" }}
                  />
                </div>
              )}
            </div>

            {showTagMenu && (
              <div style={{ position: "absolute", bottom: 1, zIndex: 10, marginTop: 40 }}>
                <TagMenu
                  selectedTagIds={selectedTagIds}
                  onSelectTag={(ids) => handleSelectTag(ids)}
                  onClose={() => setShowTagMenu(false)}
                  roomId={roomId}
                  maxTags={5}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatMessageFooter;